import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/Layout'
import RecoverPasswordComponent from '@/components/RecoverPassword'
import ResetPasswordComponent from '@/components/PasswordReset'
import Login from '@/components/Login'
import Booking from '@/components/BookingComponent'
import DynamicFormComponent from '@/components/DynamicForm'
import DynamicFormComponentEDU from '@/components/DynamicFormEDU'
import DuplicateJobComponent from '@/components/DuplicateJobComponent'
import ContactComponent from '@/components/ContactComponent'
import Welcome from '@/components/Welcome'
import OutstandingInvoicesComponent from '@/components/reports/OutstandingInvoicesComponent'
import ReportJobs from '@/components/reports/ReportJobs'
import DashboardComponent from '@/components/dashboard/DashboardComponent'
import CustomDashboard from '@/components/dashboard/CustomDashboardComponent'
import JobsDashboardComponent from '@/components/dashboard/JobsDashboardComponent'
import RecruitmentDashboardComponent from '@/components/dashboard/RecruitmentDashboardComponent'
import CloneFormComponent from '@/components/CloneFormComponent'
import SearchBookingComponent from '@/components/SearchBookingsComponent'
import SearchDhsBookingComponent from '@/components/dhs/SearchDhsBookingsComponent'
import ManualReport from '@/components/dhs/ManualReport'
import UploadsComponent from '@/components/UploadsComponent'
import NotAuthorized from '@/components/NotAuthorized'
import UsersComponent from '@/components/UsersComponent'
import DisclaimerComponent from '@/components/Disclaimer'
import CopyrightComponent from '@/components/Copyright'
import GroupList from '@/components/GroupList'
import HelpComponent from '@/components/HelpComponent'
import ViewFile from '@/components/ViewFile'

import pdfEdu from '@/components/pdfEdu'
import pdfKind from '@/components/pdfKind'

import {authorizationService} from '../authorization/authorizationService';

// todo : @mj uses this
import BookingDetails from '@/components/BookingDetails'

Vue.use(Router);

let router = new Router({
    routes: [
        {
            path: '/translationsForm',
            name: 'pdfEDU',
            component: pdfEdu,
            meta: {
                requiresAuthentication: true,
                requiresAuthorization: false
            }
        },
        {
            path: '/pdfKIND',
            name: 'pdfKIND',
            component: pdfKind,
            meta: {
                requiresAuthentication: true,
                requiresAuthorization: false
            }
        },
        {
            path: '/NotAuthorized',
            name: 'NotAuthorized',
            component: NotAuthorized,
            meta: {
                requiresAuthentication: true,
                requiresAuthorization: false
            }
        },
        {
            path: '/viewfile',
            name: 'viewfile',
            component: ViewFile,
            meta: {
                requiresAuthentication: true,
                requiresAuthorization: true
            }
        },
        {
            path: '/Booking',
            name: 'Booking',
            component: Booking,
            meta: {
                requiresAuthentication: true,
                requiresAuthorization: true
            }
        },
        {
            path: '/DynamicForm',
            name: 'DynamicForm',
            component: DynamicFormComponent,
            meta: {
                requiresAuthentication: true,
                requiresAuthorization: true
            }
        },
        {
            path: '/Form',
            name: 'Form',
            component: DynamicFormComponentEDU,
            meta: {
                requiresAuthentication: true,
                requiresAuthorization: false
            }
        },
        {
            path: '/DuplicateJob',
            name: 'DuplicateJob',
            component: DuplicateJobComponent,
            meta: {
                requiresAuthentication: true,
                requiresAuthorization: true
            }
        },
        {
            path: '/Welcome',
            name: 'Welcome',
            component: Welcome,
            meta: {
                requiresAuthentication: true,
                requiresAuthorization: false
            }
        },
        {
            path: '/CloneForm',
            name: 'CloneForm',
            component: CloneFormComponent,
            meta: {
                requiresAuthentication: true,
                requiresAuthorization: true
            }
        },
        {
            path: '/OutstandingInvoices',
            name: 'OutstandingInvoices',
            component: OutstandingInvoicesComponent,
            meta: {
                requiresAuthentication: true,
                requiresAuthorization: true
            }
        },
        {
            path: '/Jobs',
            name: 'reportJobs',
            component: ReportJobs,
            meta: {
                requiresAuthentication: true,
                requiresAuthorization: true
            }
        },
        {
            path: '/Dashboard',
            name: 'Dashboard',
            component: DashboardComponent,
            meta: {
                requiresAuthentication: true,
                requiresAuthorization: true
            }
        },
        {
            path: '/CustomDashboard',
            name: 'CustomDashboard',
            component: CustomDashboard,
            meta: {
                requiresAuthentication: true,
                requiresAuthorization: true
            }
        },
        {
            path: '/JobsDashboard',
            name: 'JobsDashboard',
            component: JobsDashboardComponent,
            meta: {
                requiresAuthentication: true,
                requiresAuthorization: true
            }
        },
        {
            path: '/RecruitmentDashboard',
            name: 'RecruitmentDashboard',
            component: RecruitmentDashboardComponent,
            meta: {
                requiresAuthentication: true,
                requiresAuthorization: true
            }
        },
        {
            path: '/SearchBooking/:jobId?',
            props: true,
            name: 'SearchBooking',
            component: SearchBookingComponent,
            meta: {
                requiresAuthentication: true,
                requiresAuthorization: true
            }
        },
        {
            path: '/SearchDhsBooking/:records',
            props: true,
            name: 'SearchDhsBooking',
            component: SearchDhsBookingComponent,
            meta: {
                requiresAuthentication: true,
                requiresAuthorization: true
            }
        },
        {
            path: '/ManualReport/:type',
            props: true,
            name: 'ManualReport',
            component: ManualReport,
            meta: {
                requiresAuthentication: true,
                requiresAuthorization: true
            }
        },
        {
            path: '/BookingDetails',
            name: 'BookingDetails',
            component: BookingDetails,
            meta: {
                requiresAuthentication: true,
                requiresAuthorization: true
            }
        },
        {
            path: '/ContactComponent',
            name: 'ContactComponent',
            component: ContactComponent,
            meta: {
                requiresAuthentication: true,
                requiresAuthorization: true
            }
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                guest: true,
                requiresAuthorization: false
            }
        },
        {
            path: '/',
            name: 'Layout',
            component: Welcome,
            meta: {
                requiresAuthentication: true,
                requiresAuthorization: false
            }
        },
        {
            path: '/ResetPassword/:passwordToken/:isEmailLink',
            name: 'ResetPasswordComponent',
            component: ResetPasswordComponent,
            meta: {
                requiresAuthentication: false,
                requiresAuthorization: false
            }
        },
        {
            path: '/RecoverPassword',
            name: 'RecoverPasswordComponent',
            component: RecoverPasswordComponent,
            meta: {
                requiresAuthentication: false,
                requiresAuthorization: true
            }
        },
        {
            path: '/Uploads',
            name: 'UploadsComponent',
            component: UploadsComponent,
            meta: {
                requiresAuthentication: true,
                requiresAuthorization: true
            }
        },
        {
            path: '/Users',
            name: 'Users',
            component: UsersComponent,
            meta: {
                requiresAuthentication: true,
                requiresAuthorization: true
            }
        },
        {
            path: '/Copyright',
            name: 'Copyright',
            component: CopyrightComponent,
            props: {
              identifier: 'copyrights'
            }
        },
        {
            path: '/Disclaimer',
            name: 'Disclaimer',
            component: DisclaimerComponent,
            props: {
              identifier: 'disclaimers'
            }
        },
        {
            path: '/Groups',
            name: 'Groups',
            component: GroupList,
            meta: {
                requiresAuthentication: true,
                requiresAuthorization: true
            }
        },
        {
            path: '/Help',
            name: 'Help',
            component: HelpComponent,
            meta: {
                requiresAuthentication: false,
                requiresAuthorization: false
            }
        }

    ]
});

router.beforeEach(async (to, from, next) => {

  let requiresAuthorization   = to.meta.requiresAuthorization === true;
  let requiresAuthentication  = to.meta.requiresAuthentication === true;
  let isGuest                 = to.meta.guest === true;
  let hasJwt                  = localStorage.getItem('jwt') !== null;

  if(requiresAuthentication) {

      if (!hasJwt) {

        next({
          name: 'login',
          params: { nextUrl: to.fullPath }
        });

      } else {

        if(requiresAuthorization) {

          const res = await authorizationService.authorize(to.fullPath);

          let data = res.data;

          if (data != null && data.result > 0) {

            next();
          } else {

            next({name: 'NotAuthorized'})
          }

        } else {
          next();
        }
      }

  } else {

    if(isGuest) {
      if(hasJwt) {
        next({name: 'Welcome'});
      } else {
        next(); // login
      }
    } else {
      next();
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js